import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common'; 
import { RouterModule } from '@angular/router'; 

import { IconComponent } from '../icon/icon.component';
import { I18nPipe } from '../../pipes/i18n.pipe';

@Component({
  selector: 'umkt-error-display',
  standalone: true,
  imports: [CommonModule, RouterModule, IconComponent, I18nPipe], 
  templateUrl: './error-display.component.html',
  styleUrls: ['./error-display.component.scss']
})
export class ErrorDisplayComponent {

  @Input() title: string = 'components.errorDisplay.defaultTitle';
  @Input() description: string = 'components.errorDisplay.defaultDescription';
  @Input() subDescription: string = 'components.errorDisplay.defaultSubDescription';

  @Input() retryCount: number = 0;
  @Output() retry: EventEmitter<void> = new EventEmitter<void>();

  private readonly MAX_RETRIES = 3;
  private router = inject(Router);


  get shouldShowRetryButton(): boolean {
    return this.retryCount < this.MAX_RETRIES;
  }

  onActionButtonClick(): void {
    if (this.shouldShowRetryButton) {
      this.retry.emit();
    } else {
      this.router.navigate(['/']);
    }
  }
}